import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  id: "stepper",
  class: "grid auto-cols-auto grid-flow-col lg:gap-2 md:gap-2 gap-0 lg:pb-4 mb:pb-4 pb-2 px-3"
}
const _hoisted_2 = {
  key: 0,
  class: "flex items-center lg:w-20 md:w-12 w-10 line-stepper"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "w-full h-1 rounded-md background-grey-lighten-4" }, null, -1)
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "rounded-full number h-10 w-10 mr-2 flex items-center justify-center" }
const _hoisted_6 = { class: "text-stepper lg:text-base md:text-sm lg:block md:block hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listStep, (item, index) => {
      return (_openBlock(), _createBlock("div", {
        class: _ctx.classStepActive(index),
        key: `${index}-steps`
      }, [
        (index > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _hoisted_3
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, _toDisplayString(index+1), 1),
          _createVNode("span", _hoisted_6, _toDisplayString(item.name), 1)
        ])
      ], 2))
    }), 128))
  ]))
}